import type { UseCase } from '@/core/shared'
import type { UserRepository } from '../domain'

export const inviteUsersWithChargers: UseCase<UserRepository, 'inviteUsersWithChargers'> = repository => {
  return async (inviteUsersWithChargers) => {
    await repository.inviteUsersWithChargers(inviteUsersWithChargers)
  }
}
